

















































import { Component, Vue } from "vue-property-decorator";
import "./footer.css";

@Component({})
export default class AppFooterComponent extends Vue {
  title = "Gabinete de políticas sociales".toUpperCase();
  tel = "809-534-2105";
  email = "notificaciones@gabsocial.gob.do";
  terminosDeUso = "https://puntosolidario.gob.do/t%C3%A9rminos-de-uso";
  politicas = "https://puntosolidario.gob.do/pol%c3%adticas-de-privacidad/";
  faq = "https://puntosolidario.gob.do/preguntas-frecuentes";
  year = new Date().getFullYear();
}
